/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductionRecord } from './productionRecord';
import { OrderItemConfigurationFormData } from './orderItemConfigurationFormData';
import { Change } from './change';
import { BatchComment } from './batchComment';


export interface OrderItemConfigurationDto { 
    amount?: number;
    assemblerEmails?: Array<string>;
    batchComments?: Array<BatchComment>;
    cancellationConfirmed?: boolean;
    configNo?: number;
    dueDate?: string;
    formData?: OrderItemConfigurationFormData;
    id?: string;
    name?: string;
    paymentAccountId?: number;
    productionRecord?: ProductionRecord;
    productionStopped?: boolean;
    status?: OrderItemConfigurationDto.StatusEnum;
    ticketIds?: Array<number>;
    unconfirmedChanges?: Array<Change>;
    version?: number;
}
export namespace OrderItemConfigurationDto {
    export const StatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        ConfirmedBySales: 'CONFIRMED_BY_SALES',
        ReadyForProduction: 'READY_FOR_PRODUCTION',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


